"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsonld_1 = require("jsonld");
const namespaces_1 = require("../namespaces");
/**
 * Provides a simple implementation of the RDF predicate range-domain provider that uses statically provided ontology.
 */
class StaticOntologyProvider {
    /**
     * Initializes a new instance of the {@link StaticOntologyProvider} class.
     * @param {object} context JSON-LD encoded RDF ontology to use as range-domain source.
     */
    constructor(ontology) {
        this.jsonLdOntology = ontology;
        this.ontology = null;
    }
    /** @inheritDoc */
    getDomainFor(predicate) {
        return this.getValueOf(predicate, namespaces_1.rdfs.domain);
    }
    /** @inheritDoc */
    getRangeFor(predicate) {
        return this.getValueOf(predicate, namespaces_1.rdfs.range);
    }
    async ensureInitialized() {
        if (this.ontology === null) {
            const ontology = await jsonld_1.promises.flatten(this.jsonLdOntology);
            const map = {};
            for (const term of ontology) {
                map[term["@id"]] = term;
            }
            this.ontology = map;
        }
    }
    async getValueOf(iri, predicate) {
        await this.ensureInitialized();
        let resource = this.ontology[iri] || null;
        if (resource !== null) {
            resource = resource[predicate] || null;
        }
        if (resource !== null) {
            resource = resource[0]["@id"] || null;
        }
        return resource;
    }
}
exports.default = StaticOntologyProvider;
//# sourceMappingURL=StaticOntologyProvider.js.map